<template>
  <div class="thousand_layout">
    <div class="right_box" v-loading="loading">
      <div class="flex_layout_between">
        <h3>{{$t('base.watchList')}}</h3>
        <!-- <div>
          <el-input placeholder="Search for your watchlist" v-model="sn" class="input-with-select" @change="getWatchlist">
            <el-button slot="append" @click="getWatchlist" icon="el-icon-search"></el-button>
          </el-input>
        </div> -->
        <div class="flex_input">
          <el-input ref="ifSellingCounts" :placeholder="$t('alert.searchWatchlist')" v-model="sn" class="input-with-select" @change="getWatchlist">
          </el-input>
            <el-button slot="append" @click="getWatchlist" icon="el-icon-search"></el-button>
        </div>
        <div class="watch_sort_status">
          <div>{{$t('colon.status')}}
            <el-select class="all_bids" v-model="Status" @change="getSelect">
              <el-option v-for="(item,index) in all_Status" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div>{{$t('colon.sort')}}
            <el-select class="all_bids all_sort" v-model="Sort" @change="getSelect">
              <el-option v-for="(item,index) in all_Sort" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
        <watch-check class="" type="watch" :list="list" @updatedWatch="updatedWatch"  v-if="!nofind"/>
        <n-o-t-n class="notfind" title="" text="No Data"  v-else-if="resultTpye==1" />
        <f-z-f class="notfind" title="" text="Pagefault" v-else/>
      <list-pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!nofind"/>
    </div>
  </div>
</template>
<script>

import { getInfo } from "@/api/public";
import WatchCheck from '@/components/list/watchcheck'
import ListPagination from '@/components/listpagination'
import FZF from "@/components/404.vue";
import NOTN from "@/components/notnull.vue";

export default {
  name: 'tabslist',
  components: { WatchCheck, ListPagination,FZF,NOTN},
  data() {
    return {
      loading:false,
      sn:'',
      pi: 1,
      ps: 60,
      TotalCount: 0,
      list:'',
      Status: '1',
      Sort: '1',
      all_Status: this.$enumInfo.watch_status,
      all_Sort: this.$enumInfo.watch_Sort,
      nofind:false,
      resultTpye: '',
    }
  },
  props: {
    userInfo: {}
  },
  created() {
    this.getWatchlist()
  },
  mounted() {},
  methods: {
    // 获取关注商品列表
    getWatchlist() {
      let that = this;
      this.loading=true;
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, pageIndex: that.pi, pageSize: that.ps, ststus: that.Status,sort:that.Sort, searchtxt: that.sn ,lag:'en'}
      this.$get(this.$interface.IsCard, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          that.list = result;
          that.loading=false
          that.TotalCount = res.count;
          if(result.length<=0){
            this.nofind=true
          }else{
            this.nofind=false
          }
            console.log("that.nofind",that.nofind, res);
        }else{
          this.nofind=true
          that.list = null;
          that.TotalCount = 0
          this.loading=false
        }
        this.resultTpye = res.result
      }).catch()
      //let data={}
    },
    // 筛选，排序
    getSelect() {
      this.getWatchlist()
    },
    // 刷新列表（子）
    updatedWatch(val){
      if(val=='watch'){
        this.getWatchlist()
      }
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getWatchlist()

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getWatchlist()
    },
  }
}

</script>
<style scoped>
@import "../../../static/css/usertabslist.css";
.flex_input{
  display: flex;
}
.flex_input button{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/watch.vue